import {Card, Spin} from "antd";
import React, {useContext, useEffect, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {BarChartOutlined} from "@ant-design/icons";
import {Pie} from "@ant-design/plots";
import {getMedicalStaffApi} from "../../api/apiInstances";
import {DentobookApplicationContext} from "../../context/DentobookApplicationContext";
import logger from "../../utils/logger";

const DashboardStatisticsCard = () => {

    const [receptionists, setReceptionists] = useState<number>(0);
    const [doctors, setDoctors] = useState<number>(0);
    const [assistants, setAssistants] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const { locale } = useContext(DentobookApplicationContext);
    const intl = useIntl();

    const pieDataMap = [
        {
            type: intl.formatMessage({ id: "doctors_statistics_label" }),
            value: doctors,
        },
        {
            type: intl.formatMessage({ id: "assistants_statistics_label" }),
            value: assistants,
        },
        {
            type: intl.formatMessage({ id: "receptionists_statistics_label" }),
            value: receptionists,
        },
    ];

    const pieConfig = {
        appendPadding: 10,
        data: pieDataMap,
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        label: {
            type: 'inner'
        },
        interactions: [
            {
                type: 'element-active',
            },
        ],
    };

    const medicalApi = getMedicalStaffApi();

    useEffect(() => {
        setLoading(true);
        medicalApi.fetchMedicalStaffCount()
            .then(res => {
                setReceptionists(res.data.receptionists!);
                setDoctors(res.data.doctors!);
                setAssistants(res.data.assistants!);
                setLoading(false);
            })
            .catch(err => {
                logger.log(err);
                setLoading(false);
            });
    }, [locale]);

    return (
        <Card bordered={true}
              styles={{body: {padding: '0'}}}
              className="dentobook-dashboard-card dentobook-dashboard-calendar-card">
            <span className="font-24">
                <span className="text-blue mr-1"><BarChartOutlined/></span> {<FormattedMessage id="statistics"/>}
            </span>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '80px 0' }}>
                    <Spin />
                </div>
            ) : (
                <Pie {...pieConfig} />
            )}
        </Card>
    )
}

export default DashboardStatisticsCard;

